// extracted by mini-css-extract-plugin
export default {"main_container":"Tnc_main_container__YJdwX","container":"Tnc_container__elhZX","title":"Tnc_title__-MBRw","desc":"Tnc_desc__nOp9I"};